import { FC } from 'react';
import { toNumber } from 'lodash';
import { FormBehavior, observer, toOnlyNumbers, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import CreditSimulationValue from './CreditSimulationValue';
import {
  type CreditSimulationValueFormValues,
  initialValues,
  validationSchema,
} from './schema';

const CreditSimulationValueContainer: FC = () => {
  const { creditProducts } = useStores();
  const navigate = useNavigate();
  const onSubmit = async (values: CreditSimulationValueFormValues) => {
    const formatedAmount = toNumber(
      toOnlyNumbers(values.creditSimulationValue),
    );
    await creditProducts.getSimulationPlans(formatedAmount);
    navigate(Routes.CREDIT_SIMULATION_INSTALLMENTS);
  };
  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <CreditSimulationValue />
    </FormBehavior>
  );
};
export default observer(CreditSimulationValueContainer);
